<template>
<div>
  <div v-if="!isMobile">
    <div
      class="container-input"
      @click.stop.prevent="toggleOptions">
      <div 
        class="input-header">
        <div style="width: 90%;">
          <div style="font-size: 14px;">
            <i class="fa-regular fa-user" />&nbsp;&nbsp;
            <strong>QUANTIDADE DE {{ $props.nomeItem.toUpperCase() }}</strong>
          </div>
          <div>
            <i v-if="optionsParsed.length <= 0">Nenhuma classificação disponível</i>
            <span
              v-else
              style="color: #757575;">{{ resumo }}</span>
          </div>
        </div>
        <div style="width: 9%; text-align: right;">
          <i
            v-if="!opened"
            :style="{ color: primaryColor }"
            class="fa-solid fa-angle-down" />
          <i
            v-else
            :style="{ color: primaryColor }"
            class="fa-solid fa-angle-up" />
        </div>
      </div>
      <div
        v-show="opened"
        @click.stop
        class="input-body">
        <div
          v-for="option in optionsParsed"
          :key="option.id"
          class="faixa-option">
          <div class="faixa-option-info">
            <strong>{{ option.nome }}</strong><br>
            <span>({{ option.descricao }})</span><br>
            <span
              v-if="getCurrentPrice(option).precoDe"
              style="color: lightgray; text-decoration: line-through;">{{ formatMoney(getCurrentPrice(option).precoDe) }}&nbsp;</span>
            <strong :style="{color: primaryColor}">{{ formatMoney(getCurrentPrice(option).preco) }}</strong>
          </div>
          <div
            class="faixa-option-quantity"
            translate="no">
            <i
              class="fa-solid fa-minus"
              style="cursor: pointer;"
              @click="sub(option)" />
            <div class="faixa-option-quantity-display">
              <strong>{{ getCurrentQuantidade(option) }}</strong>
            </div>
            <i
              class="fa-solid fa-plus"
              style="cursor: pointer;"
              @click="add(option)" />
          </div>
        </div>
        <div :style="{'visibility': isDependentOnly ? 'visible' : 'hidden'}">
          <small>É necessário adicionar ao menos 1 não dependente</small>
        </div>
        <div
          v-if="minVenda > 1 || maxVenda < Infinity"
          class="compliance-alert">
          <small v-if="minVenda > 1 && maxVenda < Infinity">O máximo de vagas para a compra dessa atividade por pessoa é: {{ maxVenda }} (caso tenha disponibilidade). E no mínimo {{ minVenda }}.</small>
          <small v-if="minVenda <= 1 && maxVenda < Infinity">O máximo de vagas para a compra dessa atividade por pessoa é: {{ maxVenda }} (caso tenha disponibilidade).</small>
          <small v-if="minVenda > 1 && maxVenda >= Infinity">O mínimo de vagas para a compra dessa atividade por pessoa é: {{ minVenda }} (caso tenha disponibilidade).</small>
        </div>
      </div>
    </div>
  </div>

  <!-- Componente Mobile -->
  <div v-else>
    <div>
      <i v-if="optionsParsed.length <= 0">Nenhuma classificação disponível</i>
    </div>
    <div
      v-for="(option, i) in optionsParsed"
      :key="option.id"
      :style="{'border-bottom': ((i >= (optionsParsed.length-1)) ? '1px solid #CCCCCC' : null)}"
      class="faixa-mobile-option">
      <div class="faixa-mobile-option-info">
        <strong>{{ option.nome }}</strong><br>
        <span>({{ option.descricao }})</span><br>
        <span
          v-if="getCurrentPrice(option).precoDe"
          style="color: lightgray; text-decoration: line-through;">{{ formatMoney(getCurrentPrice(option).precoDe) }}&nbsp;</span>
        <strong :style="{color: primaryColor}">{{ formatMoney(getCurrentPrice(option).preco) }}</strong>
      </div>
      <div
        class="faixa-mobile-option-quantity"
        translate="no">
        <i
          class="fa-solid fa-minus"
          style="cursor: pointer;"
          @click="sub(option)" />
        <div class="faixa-mobile-option-quantity-display">
          <strong>{{ getCurrentQuantidade(option) }}</strong>
        </div>
        <i
          class="fa-solid fa-plus"
          style="cursor: pointer;"
          @click="add(option)" />
      </div>
    </div>
    <div :style="{'visibility': isDependentOnly ? 'visible' : 'hidden'}">
      <small>É necessário adicionar ao menos 1 não dependente</small>
    </div>
    <div
      v-if="minVenda > 1 || maxVenda < Infinity"
      class="compliance-alert">
      <small v-if="minVenda > 1 && maxVenda < Infinity">O máximo de vagas para a compra dessa atividade por pessoa é: {{ maxVenda }} (caso tenha disponibilidade). E no mínimo {{ minVenda }}.</small>
      <small v-if="minVenda <= 1 && maxVenda < Infinity">O máximo de vagas para a compra dessa atividade por pessoa é: {{ maxVenda }} (caso tenha disponibilidade).</small>
      <small v-if="minVenda > 1 && maxVenda >= Infinity">O mínimo de vagas para a compra dessa atividade por pessoa é: {{ minVenda }} (caso tenha disponibilidade).</small>
    </div>
  </div>
</div>
</template>

<script>
import moment from 'moment';
export default {
    components: {},
    props: {
        value: {
            type: Array,
            default: () => [],
            required: false
        },
        selectedDate: {
            validator: (v) => v instanceof Date || v == null,
            default: () => null,
            required: false
        },
        options: {
            type: Object,
            default: () => ({}),
            required: true
        },
        primaryColor: {
            type: String,
            default: () => '#FF0000',
            required: true
        },
        min: {
            type: String,
            default: () => '1',
            required: true
        },
        max: {
            type: String,
            default: () => '9999',
            required: true
        },
        isMobile: {
            type: Boolean,
            default: () => false,
            required: false,
        },
        nomeItem: {
            type:  String,
            default: () => 'PESSOAS',
            required: false
        },
        moeda: {
            type: String,
            default: () => 'BRL',
            required: true
        }
    },
    emits: ['input', 'on-options-open-state-change', 'on-complience-state-change'],
    data() {
        return { opened: false };
    },
    computed: {
        optionsParsed() {
            const ops = this.$props.options;
            const chaves = Object.keys(ops);
            if(chaves.length <= 0) {
                return [];
            }

            const r = [];
            chaves.forEach((chave) => {
                r.push(ops[chave]);
            });

            r.sort((a, b) => Number(a.ordem)-Number(b.ordem));

            return r;
        },
        isDependentOnly() {
            if(!this.$props.value || this.$props.value.length <= 0) {
                return false;
            }
            for (let i = 0; i < this.$props.value.length; i++) {
                const faixa = this.$props.value[i];
                if(!faixa.dependente) {
                    return false;
                }
            }
            return true;
        },
        respectMinMax() {
            if(!this.$props.value || this.$props.value.length <= 0) {
                return false;
            }
            return this.somaQuantidade >= this.minVenda && this.somaQuantidade <= this.maxVenda;
        },
        inCompliance() {
            return !this.isDependentOnly && this.respectMinMax;
        },
        minVenda() {
            const min = Number(this.$props.min);
            if(isNaN(min)) {
                return 1;
            }
            return min;
        },
        maxVenda() {
            const max = Number(this.$props.max);
            if(isNaN(max) || max < this.min) {
                return Infinity;
            }
            return max;
        },
        somaQuantidade() {
            let soma = 0;
            for (let i = 0; i < this.$props.value.length; i++) {
                const faixa = this.$props.value[i];
                soma += faixa.quantidade;
            }
            return soma;
        },
        resumo() {
            if(!this.$props.value.length || this.$props.value.length <= 0) {
                return 'Selecione';
            }
            let r = '';
            this.$props.value.forEach(faixa => {
                const infoFaixa = this.getFaixaById(faixa.id);
                r += faixa.quantidade.toString() + ' ' + infoFaixa.nome + ', ';
            });
            return r.slice(0, -2);
        }
    },
    watch: {
        opened() {
            this.$emit('on-options-open-state-change', this.opened);
        },
        inCompliance() {
            this.$emit('on-complience-state-change', this.inCompliance);
        }
    },
    mounted() {
        this.$emit('on-complience-state-change', this.inCompliance);
        this.opened = true;
    },
    methods: {
        sub(faixa) {
            this.mudarQuantidade(faixa, -1);
        },
        add(faixa) {
            this.mudarQuantidade(faixa, 1);
        },
        mudarQuantidade(faixa, quantidade) {
            const minLimit = 0;
            const vagasRestantes = this.maxVenda - this.somaQuantidade;
            if(quantidade > vagasRestantes) {
                return false;
            }

            const current = JSON.parse(JSON.stringify(this.$props.value));
            for (let i = 0; i < current.length; i++) {
                const faixaAtual = current[i];
                if(faixaAtual.id == faixa.id) {
                    faixaAtual.quantidade += quantidade;
                    if(faixaAtual.quantidade < minLimit) {
                        return false;
                    }
                    this.$emit('input', current.filter(faixa => faixa.quantidade > 0));
                    return true;
                }
            }
            if(quantidade < minLimit) {
                return false;
            }
            current.push({
                'id': faixa.id,
                'faixa_etaria_id': faixa.faixa_etaria_id,
                'ordem': faixa.ordem,
                'quantidade': quantidade,
                'preco': this.getCurrentPrice(faixa),
                'dependente': faixa.dependente == 1,
            });
            current.sort((a, b) => Number(a.ordem)-Number(b.ordem));
            this.$emit('input', current.filter(faixa => faixa.quantidade > 0));
            return true;
        },
        getCurrentQuantidade(faixa) {
            for (let i = 0; i < this.$props.value.length; i++) {
                const faixaAdicionada = this.$props.value[i];
                if(faixaAdicionada.id == faixa.id) {
                    return faixaAdicionada.quantidade;
                }
            }
            return 0;
        },
        toggleOptions() {
            this.opened = !this.opened;
        },
        formatMoney(price) {
            let locale = 'pt-Br';

            if (this.$props.moeda === 'USD') {
                locale = 'en-US';
            }

            if(price <= 0 || price === null) {
                return 'Gratuito';
            }
            
            return Number(price).toLocaleString(locale, { style: 'currency', currency: this.$props.moeda });
        },
        getCurrentPrice(priceObj) {
            const defaultPrice = {
                'id': priceObj.id,
                'precoDe': null,
                'preco': parseFloat(priceObj.preco),
                'precoDesconto': priceObj.preco_desconto !== null ? parseFloat(priceObj.preco_desconto) : null
            };
            if(!this.$props.selectedDate) {
                return defaultPrice;
            }

            if(
                typeof priceObj.precos_sazonais !== 'object' ||
                Array.isArray(priceObj.precos_sazonais) ||
                priceObj.precos_sazonais === null
            ) {
                return defaultPrice;
            }

            const currentDate = moment(this.$props.selectedDate);
            const precosSazonaisIds = Object.keys(priceObj.precos_sazonais);
            for (let i = 0; i < precosSazonaisIds.length; i++) {
                if (
                    currentDate >= moment(priceObj.precos_sazonais[precosSazonaisIds[i]].data_inicio, 'YYYY-MM-DD') &&
                    currentDate <= moment(priceObj.precos_sazonais[precosSazonaisIds[i]].data_fim, 'YYYY-MM-DD')
                ) {
                    const price = priceObj.precos_sazonais[precosSazonaisIds[i]];
                    return {
                        'id': price.id,
                        'precoDe': (price.preco_promocao_de !== null && price.promocao == 1) ? parseFloat(price.preco_promocao_de) : null,
                        'preco': parseFloat(price.preco),
                        'precoDesconto': price.preco_desconto !== null ? parseFloat(price.preco_desconto) : null
                    };
                }
            }

            return defaultPrice;
        },
        getFaixaById(id) {
            for (let i = 0; i < this.optionsParsed.length; i++) {
                const option = this.optionsParsed[i];
                if(option.id == id) {
                    return option;
                }
            }
            return null;
        }
    }
};
</script>

<style scoped>
.container-input {
    border: 1px solid #707070;
    border-radius: 5px;
    padding: 15px;
    cursor: pointer;
}
.container-input .input-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}
.container-input .input-body {
    margin-top: 15px;
    border-top: 1px solid #707070;
}

.faixa-option {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.faixa-option-info {
    line-height: 18px;
    font-size: 14px;
    width: 79%;
}
.faixa-option-quantity {
    width: 20%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.faixa-option-quantity-display {
    width: 40px;
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    border: 1px solid #464646;
    color: #464646;
}


.faixa-mobile-option {
    padding-top: 20px;
    padding-bottom: 20px;
    border-top: 1px solid #CCCCCC;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-left: -30px;
    margin-right: -30px;
    padding-right: 30px;
    padding-left: 30px;
}

.faixa-mobile-option-info {
    line-height: 18px;
    font-size: 14px;
    width: 74%;
}
.faixa-mobile-option-quantity {
    width: 25%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.faixa-mobile-option-quantity-display {
    width: 40px;
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    border: 1px solid #464646;
    color: #464646;
}


.compliance-alert {
    padding: 10px;
    border-radius: 12px;
    background-color: #f1f1f1;
}
</style>
